import { Box, IconButton, Modal as MuiModal, styled } from "@mui/material";
import { X } from "lucide-react";

const MuiModalStyled = styled(MuiModal)({
  "& .wrapper": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "480px",
    maxWidth: "90vw",
    maxHeight: "90vh",
    borderRadius: "12px",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    paddingBottom: "16px",
  },
});

const ModalHeaderRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "6px 16px 0 16px",
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: "#fff",
  flexShrink: 0,
  paddingBottom: "8px",
});

const CloseButton = styled(IconButton)({
  padding: "8px",
  borderRadius: "10px",
  border: "1px solid rgba(116,120,121,0.16)",
  backgroundColor: "#fff",
  color: "#002129",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
});

const ModalNewUnstyled = ({
  isOpen,
  onClose,
  modalTitle,
  titleActions,
  children,
  className,
}) => (
  <MuiModalStyled open={isOpen} onClose={onClose} className={className}>
    <div className="wrapper">
      <ModalHeaderRow>
        {modalTitle}
        {titleActions ?? (
          <CloseButton onClick={onClose}>
            <X size={16} strokeWidth={2} />
          </CloseButton>
        )}
      </ModalHeaderRow>
      {children}
    </div>
  </MuiModalStyled>
);

const ModalNew = styled(ModalNewUnstyled)({});

export default ModalNew;
